<div class="p-4 w-full grow-0 mx-auto flex flex-auto items-center justify-between bg-white border border-gray-200 rounded-lg shadow">
  <div class="flex items-center space-x-2">
    <ng-content select="[title]"></ng-content>
  </div>

  <div class="flex flex-wrap items-center gap-4">
    <ng-content select="[actions]"></ng-content>
  </div>

  <div></div>
</div>
